import React, { ReactNode } from "react";
import styled from "styled-components";

const StyledGrid = styled.div`
  display: grid;

  /* 12 column grid*/
  grid-template-columns: repeat(12, 1fr);

  /* margin */
  padding-left: 24px;
  padding-right: 24px;
  padding-bottom: 24px;

  /* gutter */
  grid-column-gap: 24px;
  grid-row-gap: 24px;

  @media ${({ theme }) => theme.deprecatedBreakpoints.large} {
    grid-template-columns: repeat(8, 1fr);
  }

  @media ${({ theme }) => theme.deprecatedBreakpoints.small} {
    grid-template-columns: repeat(4, 1fr);
  }
`;

export default function Grid({ className, children }: { className?: string; children: ReactNode }) {
  return <StyledGrid className={className}>{children}</StyledGrid>;
}
